import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import TemplateSave from './template-save-modal.service';

export default angular
  .module('verifyApp.template-save-model', [uiRouter, uiBootstrap])
  .service('TemplateSaveService', TemplateSave)
  .name;



// WEBPACK FOOTER //
// ./client/components/template-save/index.js